<template>
    <div class="container pl-6">
        <v-tabs
            v-model="tab"
            tile
            height="35"
            :background-color="$vuetify.theme.dark ? 'black' : 'grey lighten-1'"
        >
            <v-tab
                v-for="item in markets"
                :key="item.tab"
                class="caption pa-0 grey--text font-weight-bold"
            >
                {{ $t(item.tab) }}
            </v-tab>
            <v-tabs-items v-model="tab" class="transparent">
                <v-tab-item v-for="item in markets" :key="item.tab">
                    <v-card flat class="transparent">
                        <v-card-text class="px-0 mt-2">
                            <component :is="item.content"></component>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-tabs>
    </div>
</template>

<script>
import About from "@/components/fairplay/markets/HorseRacing/About"
import Tutorial from "@/components/fairplay/markets/HorseRacing/Tutorial"
import Upcoming from "@/components/fairplay/markets/HorseRacing/Upcoming"
export default {
    components: { About, Tutorial, Upcoming },
    data() {
        return {
            tab: 0,
            markets: [
                {
                    tab: "market.about_market",
                    content: "About"
                }
                // {
                //   tab: 'Tutorials',
                //   content: 'Tutorial'
                // },
                // {
                //   tab: 'Upcoming Markets',
                //   content: 'Upcoming'
                // }
            ]
        }
    },
    head() {
        return {
            title: `Horse Racing Betting Exchange & Horse Racing Odds - ${process.env.APP_TITLE}`,
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content: `Live horse racing Betting and Horse Racing Odds. Place your bets to win amazing cash prices. Join ${process.env.APP_TITLE} and win Real Money.`
                },
                {
                    name: "keywords",
                    content: `horse racing bet games, horse racing games`
                }
            ]
        }
    }
}
</script>
